import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AuthService } from '../service/auth.service';

@Component({
  selector: 'app-single-opening',
  templateUrl: './single-opening.component.html',
  styleUrls: ['./single-opening.component.css']
})
export class SingleOpeningComponent implements OnInit {

  authToken = localStorage.getItem('auth');

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'auth': `${this.authToken}` }),
    withCredentials: true,
  };

  businessID = this.route.snapshot.params.businessID;
  openingID = this.route.snapshot.params.openingID;
  currentUserId = this.authService.getTokenData().userID;
  applicants = [];
  opening;
  currentSubGroup;
  currentDescription;
  offerData;
  employerData;
  isLoading = false;
  prices = [];
  day_price = 0;
  price = 0;
  allow_campaign = false;
  show_expired = true;
  deletion_date;
  company_data;
  unopened_profiles = 0;
  current_profile;
  terms_rejected = false;
  showFullDescription = false;
  matchingWishes = [];
  currentDate = new Date();
  storable_profile;
  company;
  contacted_by = [];
  already_in_list = [];
  employer_lists = [];
  rights = [
    {
      highlighted: "Kaikilla",
      normal: " organisaatiossasi on oikeus nähdä profiili",
      icon_src: "../../assets/icons/people.svg",
      selected: false,
      id: 'all_in_organization',
      can_be_seen_by_others_in_same_business: true,
    },
    {
      highlighted: "Vain",
      normal: " sinulla on oikeus",
      icon_src: "../../assets/icons/lock_icon.svg",
      selected: false,
      id: 'only_me',
      can_be_seen_by_others_in_same_business: false,
    }
  ]

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private http: HttpClient,
    private route: ActivatedRoute,
    private authService: AuthService) { }

  ngOnInit(): void {
    this.fetchOpening();
    this.startCampaign()
    this.company_data = JSON.parse(localStorage.getItem('company_' + this.businessID))[0];
    console.log(this.company_data.logo, 'ssss')
  }

  getBusinessDetails() {

    this.http.get(environment.USER_BUSINESS, this.httpOptions).subscribe(
      (res: any) => {
        if (res.status == 200) {
          this.company = res.message[0];
          document.getElementById('create-campaign-btn').click();



        }
        else {

        }

      }, (err: any) => {

        console.log("Error while finding status :: ", err);
      })


  }

  fetchOpening() {
    //Epoch time
    var date = new Date();
    var epoch = date.getTime();

    this.http.get(environment.OPENING + '/' + this.openingID, this.httpOptions).subscribe(
      (res: any) => {
        if (res.status == 200) {
          this.opening = res.message;
          if (this.opening.description_fi.length >= 200) {
            this.showFullDescription = false;
          }
          else {
            this.showFullDescription = true;
          }
          //this.fetchMatchingWishes();

          //Check if opeining can be activated for campaign
          var opening_ends_epoch = new Date(this.opening.application_ends).getTime();
          var current_date_epoch = new Date().getTime();
          if (opening_ends_epoch >= current_date_epoch) {
            if (this.opening.campaign_expires) {
              var campaign_expires_epoch = new Date(this.opening.campaign_expires).getTime();
              this.opening.campaign_expires = new Date(this.opening.campaign_expires);
              if (campaign_expires_epoch < current_date_epoch) {
                this.allow_campaign = true;
              }
              else {
                this.allow_campaign = false;
              }
            }
            else {

              this.allow_campaign = true;

            }
          }
          else {
            this.allow_campaign = true;
            this.show_expired = true;
            //Add 30 days to opening ends
            var new_date = opening_ends_epoch + (30 * 86400000);
            this.deletion_date = new Date(new_date);
          }

          //loop through applicants
          var display_lang_str = "";
          if(this.opening.applicants.length > 0){
            for (let i = 0; i < this.opening.applicants.length; i++) {
              var applicant = this.opening.applicants[i];

              var languages_obj_array = applicant.languages;
              display_lang_str = "";
              for (let i = 0; i < languages_obj_array.length; i++) {
                var lang = languages_obj_array[i];
                display_lang_str += lang.name_fi + ', ';
              }
              //remove last comma
              display_lang_str = display_lang_str.slice(0, -2);
              applicant.display_lang = display_lang_str;
            }
          }


          var current_expiracy_epoch
          var apps = [];


          this.applicants = apps;
        }
        else {
          this.opening;
        }

      }, (err: any) => {

      }
    )
  }

  fetchPublicProfile(data){


    this.http.get(environment.VALIDATE_HEADHUNTING_PROFILE + '/' + data._id, this.httpOptions).subscribe(
      (res: any) => {
        if(res.status == 200 ) {

          var obj = {
            profile: res.message[0]
          }

          var languages_obj_array = obj.profile.languages;
          var display_lang_str = "";
          var display_school_str = "";

          if(languages_obj_array.length > 0){
            for (let i = 0; i < languages_obj_array.length; i++) {
              var lang = languages_obj_array[i];
              console.log(lang);
              display_lang_str += lang.name_fi + ', ';
            }

                      //remove last comma
          display_lang_str = display_lang_str.slice(0, -2);
          obj.profile.display_lang = display_lang_str;

          }

          if(obj.profile.schools && obj.profile.schools.length > 0){
            for (let i = 0; i < obj.profile.schools.length; i++) {
              var school = obj.profile.schools[i];
              console.log(school);
              display_school_str += school.school_name + ', ';
            }

            //remove last comma
            display_school_str = display_school_str.slice(0, -2);
            obj.profile.display_school = display_school_str;

          }


          this.storable_profile = obj.profile;

          document.getElementById('oc-profile').click();
          
        }
        else {
          console.log('buu')
          this.opening;
        }
        
      }, (err: any) => {

      }
    )
  }
  startCampaign() {

    //Fetch formed prices
    this.http.get(environment.EMPLOYER_PRICING, this.httpOptions).subscribe(
      (res: any) => {
        if (res.status == 200) {

          this.prices = res.message;
          this.day_price = this.prices['feed']['ads']['price'];


        }
        else {

        }

      }, (err: any) => {

        console.log("Error while finding status :: ", err);
      })
  }

  openProfileConfirm(data) {

    this.current_profile = data;
    //Fetch formed prices
    this.http.get(environment.EMPLOYER_PRICING, this.httpOptions).subscribe(
      (res: any) => {
        if (res.status == 200) {

          this.prices = res.message;
          this.day_price = this.prices['feed']['ads']['price'];


          //Open modal
          document.getElementById('open-profile-btn').click();

        }
        else {

        }

      }, (err: any) => {

        console.log("Error while finding status :: ", err);
      })


  }

  randomName() {
    var etunimet = ['Aada', 'Aamu', 'Aappo', 'Aapo', 'Aappu', 'Aarne', 'Aarni', 'Aaro', 'Aarre', 'Aatu', 'Aatto', 'Ahti', 'Ahto', 'Aida', 'Aija', 'Aila', 'Aili', 'Aimo', 'Aina', 'Aini', 'Aino'];
    var sukunimet = ['Meikäläinen', 'Mäkinen', 'Virtanen', 'Korhonen', 'Koskinen', 'Hämäläinen', 'Laine'];

    var etunimi = etunimet[Math.floor(Math.random() * etunimet.length)];
    var sukunimi = sukunimet[Math.floor(Math.random() * sukunimet.length)];
    return etunimi;
  }

  openProfile(data) {

    var terms_accepted = (<HTMLInputElement>document.getElementById('accept_terms')).checked;

    if (!terms_accepted) {
      this.terms_rejected = true;
      return;
    }

    var req = {
      userID: data.token,
      openingID: this.openingID,
      type: 'application_profile_opening'
    }


    this.http.post(environment.OPENING_OPEN_PROFILE, req, this.httpOptions).subscribe(
      (res: any) => {
        if (res.status == 200) {
          document.getElementById('close-open-profile').click();
          this.fetchOpening();

        }
        else {
          console.log('buu')
          this.opening;
        }

      }, (err: any) => {

      }
    )
  }

  routeProfile(data) {
    this.router.navigate(['/' + this.businessID + '/openings/profile-opened/application/' + this.openingID + '/' + data._id])
  }

  fetchMPOfferDetails(data) {


    this.http.get(environment.MARKETPLACE_EMPLOYER + '/' + data.employerID, this.httpOptions).subscribe(
      (res: any) => {
        if (res.status == 200) {
          this.offerData = data;
          this.employerData = res.message;
          this.currentDescription = data.description;
          document.getElementById('details-btn').click();
        }
        else {
          console.log('buu')
          this.opening;
        }

      }, (err: any) => {

      }
    )

  }

  deleteOpening() {
    var elm = (<HTMLInputElement>document.getElementById('deletion-reason')).value;

    if (elm == "" || elm == null) {
      alert('Anna poistamisen syy')
      return;
    }

    var req = {
      deletion_reason: elm,
    }

    this.http.put(environment.EMPLOYER_DELETE_OPENING + '/' + this.openingID, req, this.httpOptions).subscribe(
      (res: any) => {
        if (res.status == 200) {
          document.getElementById('close-confirm-modal').click();
          this.router.navigate(['/' + this.businessID + '/openings/standard'])

        }
        else {
          alert(
            'Poistaminen ei onnistunut. Ole hyvä ja yritä uudelleen'
          )
        }

      })
  }

  openCity(evt, cityName) {
    // Declare all variables
    var i, tabcontent, tablinks;


    // Get all elements with class="tabcontent" and hide them
    tabcontent = document.getElementsByClassName("tabcontent");
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
    }

    // Get all elements with class="tablinks" and remove the class "active"
    tablinks = document.getElementsByClassName("tablinks");
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(" active", "");
    }

    // Show the current tab, and add an "active" class to the button that opened the tab
    document.getElementById(cityName).style.display = "block";
    evt.currentTarget.className += " active";
  }

  updatePrice() {
    var camp_value = parseInt((<HTMLInputElement>document.getElementById('campaign')).value);

    if (camp_value && camp_value > 0) {

      var feed_ad_price = this.day_price;
      this.price = feed_ad_price * camp_value;



    }
    else {
      if (camp_value < 0) {
        alert("Kampanjan arvon tulee olla positiivinen");
      }
    }
  }

  increaseCampaign() {
    var opening_ends = this.opening.application_ends;

    var camp_value = parseInt((<HTMLInputElement>document.getElementById('campaign')).value);

    if ((<HTMLInputElement>document.getElementById('cost_center')).value) {
      var cost_center = (<HTMLInputElement>document.getElementById('cost_center')).value;
    }
    else {
      var cost_center = "";
    }

    //Add camp_value to current date
    var date = new Date();
    var epoch = date.getTime();
    var new_date = epoch + (camp_value * 86400000);
    var opening_ends_epoch = new Date(opening_ends).getTime();

    if (new_date > opening_ends_epoch) {
      alert('Kampanjan kesto ei voi olla pidempi kuin avoimen työpaikan hakuaika. Lisää ilmoituksen kestoa pidemmälle.')
      return;
    }

    var req = {
      days: camp_value,
      openingID: this.openingID,
      cost_center: cost_center,
    }

    this.http.put(environment.EMPLOYER_CREATE_CAMPAIGN, req, this.httpOptions).subscribe(
      (res: any) => {
        if (res.status == 200) {
          this.fetchOpening();
          document.getElementById('create-campaign-btn').click();

        }
        else {
          alert(
            'Poistaminen ei onnistunut. Ole hyvä ja yritä uudelleen'
          )
        }

      })

  }

  goBack() {
    window.history.back();
  }

  fetchMatchingWishes() {
    var wellfarearea = this.opening.location.wellFareAreaID;
    var mdtype = this.opening.mdType['id'];

    var query_string = '?wellfarearea=' + wellfarearea + '&mdtype=' + mdtype;
    this.http.get(environment.MATCHING_WISHES + query_string, this.httpOptions).subscribe(
      (res: any) => {
        if (res.status == 200) {
          var ms = res.message;

          //Count how many is unopened
          for (let i = 0; i < ms.length; i++) {
            var elm = ms[i];
            switch (elm.mdTypeID) {
              case 1001:
                elm.bgClass = 'g-bg-green';
                elm.borderColor = 'g-bg-green-border';
                elm.opening_image = 'stethoscope'
                break;
              case 1002:
                elm.bgClass = 'g-bg-green';
                elm.borderColor = 'g-bg-green-border';
                elm.opening_image = 'stethoscope'
                break;
              case 1003:

                elm.bgClass = 'g-bg-red';
                elm.borderColor = 'g-bg-red-border';
                elm.opening_image = 'injection'
                break;
              case 1004:
                elm.bgClass = 'g-bg-red';
                elm.borderColor = 'g-bg-red-border';
                elm.opening_image = 'injection'
                break;
              case 1005:
                elm.bgClass = 'g-bg-yellow';
                elm.borderColor = 'g-bg-yellow-border';
                elm.opening_image = 'tooth'
                break;
              case 1006:
                elm.bgClass = 'g-bg-yellow';
                elm.borderColor = 'g-bg-yellow-border';
                elm.opening_image = 'tooth'
                break;
              case 1008:
                elm.bgClass = 'g-bg-yellow';
                elm.borderColor = 'g-bg-yellow-border';
                elm.opening_image = 'tooth'
                break;
              case 10010:
                elm.bgClass = 'g-bg-blue';
                elm.borderColor = 'g-bg-blue-border';
                elm.opening_image = 'student'
                break;
              default:
                break;
            }
          }

          this.matchingWishes = ms;
        }
        else {
          console.log('ei löytyny mittää vastaavia')
        }

      }, (err: any) => {

      }
    )
  }

  setViewMore() {
    this.showFullDescription = !this.showFullDescription;
  }

  routeMatchingProfile(data) {
    this.router.navigate(['/' + this.businessID + '/wishlist/profile-opened/wishlist/' + data._id + '/' + data.userID])

  }

  saveProfileToList(data) {
    console.log(data, 1);
    this.storable_profile = data;
    this.already_in_list = [];

    console.log(this.storable_profile, 1);

    this.http.get(environment.EMPLOYER_LISTS, this.httpOptions).subscribe(
      (res: any) => {
        if (res.status == 200) {
          this.employer_lists = res.message;
          document.getElementById('save-list').click();

          this.already_in_list = this.employer_lists
            .filter(item =>
              item.profiles && item.profiles.some(profile => profile._id === data._id)
            )
            .map(item => ({
              id: item._id,
              name: item.name
            }));

          console.log(this.already_in_list, 2)
        }
        else {
          this.employer_lists = [];
          document.getElementById('save-list').click();
          console.log('buu')
        }

      }, (err: any) => {

      }
    )
  }

  saveToList() {
    var storable_profile = this.storable_profile;

    //find selected lists
    var selected_lists = this.employer_lists.filter(x => x.selected == true);
    console.log(selected_lists, storable_profile, 3);

    if (selected_lists.length == 0) {
      alert('Valitse lista');
      return;
    }

    //Check if profile is already in selected list
    var is_in_list = false;
    for (let i = 0; i < selected_lists.length; i++) {
      const list = selected_lists[i];
      if (list.profiles.some(profile => profile._id === storable_profile.userID)) {
        is_in_list = true;
      }
    }

    if (is_in_list) {
      alert('Profiili on jo valitsemissasi listoissa');
      return;
    }

    var selected_lists_ids = selected_lists.map(x => x._id);

    var req = {
      lists: selected_lists_ids,
      userID: this.storable_profile._id
    }

    this.http.post(environment.SAVE_PROFILE_TO_LIST, req, this.httpOptions).subscribe(
      (res: any) => {
        if (res.status == 200) {
          console.log(res);
          document.getElementById('close-save-list').click();
        }
        else {
          console.log('buu')
        }

      }, (err: any) => {
        console.log(err)
      })
  }

  selectList(list) {

    for (let i = 0; i < this.employer_lists.length; i++) {
      var elm = this.employer_lists[i];

      if (elm._id == list._id) {
        elm.selected = !elm.selected;
      }

    }

  }

  createANewList() {
    var selected_right = this.rights.filter(x => x.selected == true);
    var title = (<HTMLInputElement>document.getElementById('list-title')).value;
    var description = (<HTMLInputElement>document.getElementById('list-description')).value;

    var req = {
      title: title,
      description: description,
      right: selected_right[0].id,
      profiles: [this.storable_profile._id],
      can_be_seen_by_others_in_same_business: selected_right[0].can_be_seen_by_others_in_same_business,
    }

    //Save list 

    this.http.post(environment.EMPLOYER_LISTS, req, this.httpOptions).subscribe(
      (res: any) => {
        if (res.status == 200) {
          console.log(res);
          document.getElementById('close_create_new_list').click();
          setTimeout(() => {
            document.getElementById('list-created').click();
          }, 100);
        }
        else {
          console.log('buu')
        }

      }, (err: any) => {

      }
    )
  }

  selectRight(right) {
    for (let i = 0; i < this.rights.length; i++) {
      const elm = this.rights[i];
      elm.selected = false;
    }

    for (let i = 0; i < this.rights.length; i++) {
      var elm = this.rights[i];
      if (elm == right) {
        elm.selected = true;
      }
    }

    console.log(this.rights)

  }

  addSingleProfileToList(data) {
    var profileID = data._id;
    var req = {
      profileID: profileID,
      listID: data._id
    }
  }

  removeItemFromList(item) {
    console.log(item, this.storable_profile);
    var req = {
      profileID: this.storable_profile._id,
      lists: [item.id]
    }

    this.http.post(environment.REMOVE_PROFILE_FROM_LIST, req, this.httpOptions).subscribe(
      (res: any) => {
        if (res.status == 200) {
          console.log(res);
          //Remove all lists from already_in_list
          for (let i = 0; i < this.already_in_list.length; i++) {
            var person = this.already_in_list[i];

            if (person.id == item.id) {
              this.already_in_list.splice(i, 1);
            }

          }
        }
        else {
          console.log('buu')
        }

      }, (err: any) => {

      }
    )

  }

  routeToLists(){
    //Close modal
    document.getElementById('close-list-created').click();
    //Route to lists
    this.router.navigate(['/' + this.businessID + '/lists']);
  }

  sendMessage() {

    var profilePicture;
    console.log(this.storable_profile)
    profilePicture = this.storable_profile['profilePicture'];

    var req = {
      openingID: this.openingID,
      firstName: this.storable_profile.firstName,
      mdType: {},
      logo: this.opening.logo,
      userID: this.storable_profile._id,
      type: 'application',
      businessID: this.businessID,
      profilePicture: profilePicture,
    }

    this.http.post(environment.MESSAGE_LIST, req, this.httpOptions).subscribe(
      (res: any) => {
        if (res.status == 200) {
          this.routeMessages(res.message[0]._id)
        }
        else {
          console.log('buu')
        }

      }, (err: any) => {

      }
    )
  }

  routeMessages(id) {
    console.log(id);
    localStorage.setItem('ACTIVE_MSG_LIST', JSON.stringify(id));
    this.router.navigate(['/' + this.businessID + '/messages']);
  }

}
